/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const paginationTokens = {
  CoreMargin: '10px 0',
  ItemBackgroundColorInitial: 'rgba(0, 0, 0, 0)',
  ItemBackgroundColorHover: '#dedfdf',
  ItemBackgroundColorActive: '#232b2b',
  ItemBorderColorActive: '#2c67b5',
  ItemBorderColorFocus: 'rgba(0, 0, 0, 0.415)',
  ItemBorderRadius: '3px',
  ItemColorInitial: '#394040',
  ItemColorHover: '#1c2222',
  ItemColorActive: '#ebecec',
  ItemFontSize: '14px',
  ItemFontWeight: '500',
  ItemFontLeading: '30px',
  ItemMargin: '0 2px',
  ItemWidth: '30px',
  SpacerLeading: '25px',
  SpacerWidth: '16px',
} as const;
